import { observable } from 'mobx';

export type TravelAuthorizationElementResponseArgs = {
  id: number;
  service_text: string;
};

export type TravelAuthorizationElementArgs = {
  id: number;
  serviceText: string;
};

export const convertTravelAuthorizationElementResponseToArgs = (
  response: TravelAuthorizationElementResponseArgs
) => {
  const args: TravelAuthorizationElementArgs = {
    id: response.id,
    serviceText: response.service_text
  };
  return args;
};

export default class TravelAuthorizationElement {
  @observable id: number;
  @observable serviceText: string;

  constructor(args: TravelAuthorizationElementArgs) {
    this.id = args.id;
    this.serviceText = args.serviceText;
  }

  get type() {
    return 'travel_authorization';
  }

  get startDate() {
    return null;
  }

  get endDate() {
    return null;
  }

  get title() {
    return '査証・渡航認証関連';
  }

  get summary() {
    return `[査証] ${this.serviceText}`;
  }

  get name() {
    return this.serviceText;
  }

  get mappingDescription() {
    return this.title;
  }

  detail() {
    return '';
  }
}
